export default __webpack_public_path__ + "static/media/logo.5cba6886.png";